import { Directive, ElementRef, forwardRef, HostListener, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Directive({
    selector: 'cwc-input[formControlName], cwc-input[ngModel], cwc-textarea[formControlName], cwc-textarea[ngModel]',
    standalone: true, // Compatible con proyectos standalone
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: forwardRef(() => CwcInputValueAccessorDirective),
            multi: true
        }
    ]
})
export class CwcInputValueAccessorDirective implements ControlValueAccessor {
    private onChange = (value: any) => { };
    private onTouched = () => { };

    constructor(private el: ElementRef, private renderer: Renderer2) { }

    writeValue(value: any): void {
        this.renderer.setProperty(this.el.nativeElement, 'value', value);
    }

    @HostListener('cwcChange', ['$event.detail'])
    handleChange(value: any): void {
        const inputElement = this.el.nativeElement;
        const inputType = inputElement.getAttribute('type'); // Obtener el tipo del input

        if (inputType === 'email') {
            if (this.isEmail(value)) {
                this.clearError(inputElement); // Remover errores si es válido
                this.onChange(value);
            } else {
                this.setError(inputElement); // Agregar atributos de error
            }
        } else {
            this.onChange(value);
        }
    }

    @HostListener('blur')
    handleBlur(): void {
        this.onTouched();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }
    setDisabledState(isDisabled: boolean): void {
        this.renderer.setProperty(this.el.nativeElement, 'disabled', isDisabled);
    }

    private isEmail(value: string): boolean {
        const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
        return emailPattern.test(value);
    }
    private setError(inputElement: any): void {
        const errorMessage = inputElement.getAttribute('data-error') || 'Formato no válido';
        this.renderer.setAttribute(inputElement, 'status', 'error');
        this.renderer.setAttribute(inputElement, 'status-message', errorMessage);
    }

    private clearError(inputElement: any): void {
        this.renderer.removeAttribute(inputElement, 'status');
        this.renderer.removeAttribute(inputElement, 'status-message');
    }
}
